import { FaMapMarkerAlt } from "react-icons/fa"
import MapBlade from "@organic-return/foundation-react/src/components/Blades/MapBlade"
import { graphql, navigate, useStaticQuery } from "gatsby"
import React from "react"

const DevelopmentsListing = ({ module }: any) => {
    const data = useStaticQuery(graphql`
      query {
          allAgilityDevelopments {
            nodes {
              customFields {        
                name
                latitude
                longitude
              }
              path
            }
          }
      }
    `)

    const markers = data.allAgilityDevelopments?.nodes?.map((development) => {
        return {
            address: {
                text: development.customFields.name
            },
            location: {
                lat: parseFloat(development.customFields.latitude),
                lng: parseFloat(development.customFields.longitude),
            },
            path: development.path
        }
    })

    return (
        <div className="relative max-w-screen-2xl mx-auto">
            <MapBlade
                className="aspect-[4/3] p-8 md:p-10 lg:p-14 xl:p-20"
                locations={markers}
                mapWrapperProps={{
                    className: "h-full",
                    useSimpleMarker: true,
                    markerClustererProps: {
                        options: {
                            ignoreHidden: true,
                        }
                    }
                }}
                mapProps={{
                    mapContainerStyle: {
                        width: "100%",
                        height: "100%",
                    }
                }}
                mapClick={(item) => { navigate(item.path) }}
            >
            </MapBlade>
            <div className="w-full grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 md:gap-10 lg:gap-14 xl:gap-16 inverted p-8 md:p-10 lg:p-14 xl:p-20">
                {markers && markers.map((marker, index) => (
                    <a href={marker.path} key={index} className="flex flex-row flex-nowrap justify-start gap-x-5">
                        <FaMapMarkerAlt className="text-accent text-4xl" />
                        <span className="text-xl font-black tracking-widest">{marker.address.text}</span>
                    </a>
                ))}
            </div>
        </div>
    )
}

export default DevelopmentsListing